import _ from 'lodash'
import { validateInvestmentFundAllocation, validateInvestmentFundTotalAllocation } from './validation'
import MESSAGES from 'core/data-model/constants/validation-messages'

const riskLevelDigestable = (insuredRiskLevel) => (fund) => fund.riskLevel <= insuredRiskLevel

export const _calculateAllocation = async (
  fundAllocations,
  insuredRiskLevel,
  validateFundAllocation,
  validateFundTotalAllocation
) => {
  const selectedFunds = _.filter(fundAllocations, 'selected')
  let totalFundAllocation = _.sumBy(selectedFunds, 'fundAllocation')

  let [fundAllocations$, totalAllocation$] = await Promise.all([
    Promise.all(_.map(selectedFunds, validateFundAllocation)),
    validateFundTotalAllocation(totalFundAllocation),
  ])
  const riskLevelDigestableForInsured = riskLevelDigestable(insuredRiskLevel)
  let resultAllocations = _.map(fundAllocations$, (fund$) => ({
    ...fund$.value,
    errors: fund$.getErrorMessages(),
    riskLevelDigestable: riskLevelDigestableForInsured(fund$.value),
  }))
  if (!totalAllocation$.isOk) {
    _.each(resultAllocations, (fundAllocation) => {
      fundAllocation.errors && fundAllocation.errors.push(MESSAGES.RULE_IWEALTHY_MAX_FUND_LIMIT)
    })
  }
  return {
    fundAllocations: resultAllocations,
    totalAllocation: { value: totalAllocation$.value, errors: totalAllocation$.getErrorMessages() },
  }
}
export const calculateTotalAllocation = async (displayProductQuery, insuredRiskLevel, fundAllocations, getFunds) => {
  const validateFundAllocationForProduct = validateInvestmentFundAllocation(displayProductQuery, getFunds)
  const validateTotalAllocationForProduct = validateInvestmentFundTotalAllocation(displayProductQuery, getFunds)
  return _calculateAllocation(
    fundAllocations,
    insuredRiskLevel,
    validateFundAllocationForProduct,
    validateTotalAllocationForProduct
  )
}
